import { Component, OnInit } from '@angular/core';
import {AuthenticateService} from "../../auth/authentication.service";
import {Router} from "@angular/router";
import {User} from "../../user/user.mode";

@Component({
  selector: 'common-dashboard',
  templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnInit{

  constructor(
    private authenticate:AuthenticateService,
    private router: Router
  ){

  }

  userInfo:User;

  ngOnInit() {
    this.authenticate.getUserInfo().subscribe(res => {
        let resultBody = JSON.parse(res['_body']);
        if(resultBody.status === 'success'){
          let userObj = resultBody.body['userInfo'];
          this.userInfo = new User(
            userObj['userNo'],
            userObj['userId'],
            userObj['vendorSeq'],
            userObj['vendorName'],
            userObj['userType'],
            userObj['latestAt'],
            userObj['useYn']
          );

          if(this.userInfo.userType === 'HQ' || this.userInfo.userType === 'LO'){
            this.router.navigateByUrl('/app/calculate/vendor');
          }else{
            this.router.navigateByUrl('/app/calculate/admin');
          }

        }
      },
      error => {
        this.router.navigateByUrl('/common/sign-in/expired');
      })
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/calculate/dashboard/dashboard.component.ts